export interface RandomSource { next: () => number; range: (min: number, max: number) => number; int: (min: number, max: number) => number; pick: <T>(values: readonly T[]) => T; }

export function hashSeed(input: string | number): number {
  const text = String(input); let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) { hash ^= text.charCodeAt(index); hash = Math.imul(hash, 16777619); }
  return hash >>> 0;
}

export function createRandom(seed: string | number): RandomSource {
  let state = hashSeed(seed) || 0x6d2b79f5;
  const next = (): number => {
    state += 0x6d2b79f5;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    range: (min, max) => min + next() * (max - min),
    int: (min, max) => Math.floor(min + next() * (max - min + 1)),
    pick: <T>(values: readonly T[]): T => { const value = values[Math.floor(next() * values.length)]; if (value === undefined) throw new Error('Cannot pick from an empty collection.'); return value; },
  };
}
